<template>
  <div>
    <template v-if="noCompetitorBrands">
      <div class="noBrand">
        <RequireCompetitorBrand />
      </div>
    </template>
    <template v-else>
      <section class="p-box">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit($event, onSubmit)">
            <div class="p-box__body">
              <div class="c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <section class="p-box">
                      <header class="p-box__header">
                        <h3 class="p-box__title">{{ $t('models.competitor.modelName') }}</h3>
                      </header>
                      <div class="p-box__body">
                        <Loading v-show="loading" />
                        <template v-if="dataLoaded">
                          <div class="p-formGrid">
                            <div class="p-formGrid__items">
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__8 p-formGrid__item__l__8">
                                <label for="" class="c-formLabel">{{ $t('models.competitor.name') }} ※{{ $t('labels.required') }}</label>
                                <ValidationProvider key="name_validation" v-slot="{ errors, value, handleChange }" v-model="competitor.attributes.name" :name="$t('models.competitor.name')" rules="required">
                                  <input :disabled="!showMoreThanEditorAuthority" :value="value" type="text" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                  <ValidationError :error="errors[0]" />
                                </ValidationProvider>
                              </fieldset>
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__8 p-formGrid__item__l__8">
                                <label for="" class="c-formLabel">{{ $t('models.competitor.competitor_brand') }} ※{{ $t('labels.required') }}</label>
                                <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="competitor.attributes.competitor_brand_id" :name="$t('models.competitor.competitor_brand')" rules="required">
                                  <div class="c-select">
                                    <select :disabled="!showMoreThanEditorAuthority" :value="value" @change="handleChange">
                                      <option value="">{{ $t('labels.placeholder.select') }}</option>
                                      <option v-for="brand in competitorBrands" :key="brand.id" :value="brand.id">
                                        {{ brand.attributes.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <ValidationError :error="errors[0]" />
                                </ValidationProvider>
                              </fieldset>
                            </div>
                          </div>
                        </template>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-box__body">
              <div class="c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <section class="p-box">
                      <header class="p-box__header">
                        <h3 class="p-box__title">{{ $t('pages.CompaniesLocationStoreCompetitor.reviewSiteForm.header') }}</h3>
                      </header>
                      <div class="p-box__body">
                        <Loading v-show="loading" />
                        <template v-if="dataLoaded">
                          <div class="p-box__info">
                            <div class="c-info">
                              <div class="c-info__icon">
                                <Icon name="iconQuestion" />
                              </div>
                              <div class="c-info__content">
                                <p>{{ $t('pages.CompaniesLocationStoreCompetitor.reviewSiteForm.info') }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="p-formGrid">
                            <div class="siteFilter c-select">
                              <select v-model="displayAllSites" @change="handleResetCompetitorSites">
                                <option value="false">{{ store.attributes.business_type_name }}</option>
                                <option value="true">{{ $t('labels.allReviewSites') }}</option>
                              </select>
                            </div>
                            <div class="p-formGrid__items">
                              <fieldset
                                v-for="site in filteredSites"
                                :key="site.id"
                                class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12"
                              >
                                <label class="c-formLabel">
                                  <div class="c-icon c-icon--square">
                                    <KkSiteIcon :name="site.siteType" />
                                  </div>
                                  <p>{{ site.name }}（URL）</p>
                                </label>
                                <ValidationProvider
                                  v-slot="{ errors, value, handleChange }"
                                  :key="`${site.siteType}_validation`"
                                  v-model="site.url"
                                  :rules="`${site.siteType}_url`"
                                  :name="`${site.name} URL`"
                                  :vid="`${site.siteType}_validation`"
                                >
                                  <input :disabled="!showMoreThanEditorAuthority" :value="value" type="url" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                  <ValidationError :error="errors[0]" />
                                </ValidationProvider>
                              </fieldset>
                            </div>
                          </div>
                        </template>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <footer v-show="dataLoaded" class="p-box__footer">
              <div v-if="showMoreThanEditorAuthority" class="c-button c-button--right">
                <router-link :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid }}" class="c-button__item c-button__item--outline-cancel">
                  {{ $t('labels.cancel') }}
                </router-link>
                <button class="c-button__item c-button__item--primary">
                  {{ $t('labels.save') }}
                </button>
              </div>
            </footer>
          </form>
        </ValidationObserver>
      </section>
    </template>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import ValidationError from '../components/ValidationError'
import RequireCompetitorBrand from '../components/CompaniesLocationStoreCompetitor/RequireCompetitorBrand'
import Loading from '../components/Loading.vue'
import { KkSiteIcon } from '../components/base'
import iconCrossPath from '../../../images/common/icon_cross.svg'
import Icon from '../components/Icon'
import ImgIconPlusRed from '../../../images/common/icon_plus_red.svg'

export default {
  name: 'CompaniesLocationStoreCompetitor',
  components: {
    RequireCompetitorBrand,
    ValidationError,
    Loading,
    KkSiteIcon,
    Icon,
  },
  data () {
    return {
      prefectures: gon.prefectures,
      iconCrossPath,
      ImgIconPlusRed,
      displayAllSites: false,
    }
  },
  computed: {
    ...mapState({
      store: state => state.companiesLocationStore.data,
      storeLoading: state => state.companiesLocationStore.loading,
      competitor: state => state.companiesStoreCompetitor.data,
      competitorSites: state => state.companiesStoreCompetitor.competitorSites,
      competitorLoading: state => state.companiesStoreCompetitor.loading,
      competitorBrands: state => state.companiesCompetitorBrands.data,
      competitorBrandsLoading: state => state.companiesCompetitorBrands.loading,
    }),
    ...mapGetters({
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeUuid() {
      return this.$route.params.store_uuid
    },
    competitorId() {
      return this.$route.params.competitor_id
    },
    loading() {
      return this.competitorLoading || this.competitorBrandsLoading || this.storeLoading
    },
    dataLoaded() {
      return this.competitor && this.competitorBrands && this.store && !this.loading
    },
    noCompetitorBrands() {
      return !this.competitorBrands?.length && !this.competitorBrandsLoading
    },
    filteredSites() {
      const businessTypeId = this.store?.attributes?.business_type_id
      return this.displayAllSites === 'true' ? this.competitorSites : this.competitorSites.filter(site => site.businessTypes.includes(businessTypeId))
    },
  },
  created() {
    this.readStore({ company_uuid: this.companyUuid, store_uuid: this.storeUuid })
    this.readCompetitorBrands(this.companyUuid)
    if (this.competitorId) {
      this.readCompetitor({ company_uuid: this.companyUuid, store_uuid: this.storeUuid, competitor_id: this.competitorId })
    } else {
      this.initNewCompetitor()
    }
  },
  methods: {
    ...mapActions({
      readStore: 'companiesLocationStore/readStore',
      initNewCompetitor: 'companiesStoreCompetitor/initNewCompetitor',
      readCompetitor: 'companiesStoreCompetitor/readCompetitor',
      createCompetitor: 'companiesStoreCompetitor/createCompetitor',
      updateCompetitor: 'companiesStoreCompetitor/updateCompetitor',
      resetCompetitorSites: 'companiesStoreCompetitor/resetCompetitorSites',
      readCompetitorBrands: 'companiesCompetitorBrands/readCompetitorBrands',
    }),
    handleResetCompetitorSites() {
      this.resetCompetitorSites()
    },
    async onSubmit() {
      const result = await this.$refs.form.validate()
      if (!result.valid) {
        alert(this.$t('messages.invalid'))
        return
      }
      if (this.competitorId) {
        const isSuccess = await this.updateCompetitor({ company_uuid: this.companyUuid, store_uuid: this.storeUuid, competitor_id: this.competitorId })
        if (isSuccess) this.goToCompetitorsPage()
      } else {
        const isSuccess = await this.createCompetitor({ company_uuid: this.companyUuid, store_uuid: this.storeUuid })
        if (isSuccess) this.goToCompetitorsPage()
      }
    },
    goToCompetitorsPage() {
      this.$router.push({ name: 'CompaniesLocationStore', params: { company_uuid: this.companyUuid, store_uuid: this.storeUuid }, query: { tab: 'competitor' } })
    }
  }
}
</script>

<style lang="scss" scoped>
.siteFilter {
  margin-bottom: 16px;
  width: 200px;
}

.noBrand {
  margin-top: 32px;
}
</style>
